export default __webpack_public_path__ + "static/broderie12.inspirations-e8ddd354a0fd14b06140d3820c480a2a.jpg";